(() => {
  const namespace = (window.AnnurNewsletterOffer = window.AnnurNewsletterOffer || {});

  function initializeForm(form) {
    if (form.dataset.annurNewsletterInitialized === 'true') return;

    const submitButton = form.querySelector('[data-annur-newsletter-submit]');
    const honeypot = form.querySelector('[data-annur-newsletter-honeypot]');
    if (!submitButton || !honeypot) return;

    form.dataset.annurNewsletterInitialized = 'true';
    form.addEventListener('submit', (event) => {
      if (honeypot.value.trim() || form.dataset.annurNewsletterSubmitting === 'true') {
        event.preventDefault();
        return;
      }

      if (!form.checkValidity()) return;

      form.dataset.annurNewsletterSubmitting = 'true';
      submitButton.disabled = true;
      submitButton.textContent = submitButton.dataset.processingLabel || 'Procesando...';
    });
  }

  function initialize(root = document) {
    const forms = [];
    if (root.matches?.('form.annur-newsletter-offer__native-form')) forms.push(root);
    forms.push(...(root.querySelectorAll?.('form.annur-newsletter-offer__native-form') || []));
    forms.forEach(initializeForm);
  }

  namespace.initialize = initialize;
  initialize();

  if (namespace.sectionLoadBound) return;
  namespace.sectionLoadBound = true;
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
